import { render, staticRenderFns } from "./areaDia.vue?vue&type=template&id=6be06034&scoped=true"
import script from "./areaDia.vue?vue&type=script&lang=js"
export * from "./areaDia.vue?vue&type=script&lang=js"
import style0 from "./areaDia.vue?vue&type=style&index=0&id=6be06034&prod&lang=less&scoped=true"
import style1 from "./areaDia.vue?vue&type=style&index=1&id=6be06034&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be06034",
  null
  
)

export default component.exports